/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, count: NonNullable<unknown> }} Table_Server_Page_SummaryInputs */

const en_table_server_page_summary = /** @type {(inputs: Table_Server_Page_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} · ${i?.count} row(s)`)
};

const pt_br2_table_server_page_summary = /** @type {(inputs: Table_Server_Page_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} · ${i?.count} linha(s)`)
};

/**
* | output |
* | --- |
* | "Page {page} · {count} row(s)" |
*
* @param {Table_Server_Page_SummaryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_server_page_summary = /** @type {((inputs: Table_Server_Page_SummaryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Server_Page_SummaryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_server_page_summary(inputs)
	return pt_br2_table_server_page_summary(inputs)
});